import React, { useEffect, useState } from "react";
import { Mail, RefreshCw, Search } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

// Issue G — proof of every email LocaNest attempted to send (to / subject / sent / error).
export default function EmailLogPanel() {
  const [data, setData] = useState(null);
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);

  const load = (query = q) => {
    setBusy(true);
    api.get("/admin/email-log", { params: { q: query || undefined, limit: 50 } }).then(({ data }) => setData(data)).catch(() => setData({ items: [], total: 0, sent: 0, failed: 0 })).finally(() => setBusy(false));
  };
  useEffect(() => {
    const t = setTimeout(() => load(q), 400);
    return () => clearTimeout(t);
    /* eslint-disable-next-line */
  }, [q]);

  return (
    <section className="mt-12" data-testid="admin-email-log">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-[#C85A32]">Delivery proof</div>
          <h2 className="font-display text-2xl mt-1 flex items-center gap-2"><Mail size={20} /> Email log</h2>
          {data && <div className="text-xs text-[#5C6B7A] mt-1" data-testid="email-log-summary">{data.total} attempts · <span className="text-[#2B3A67] font-semibold">{data.sent} sent</span> · <span className="text-red-600 font-semibold">{data.failed} failed</span></div>}
        </div>
        <form className="flex gap-2" onSubmit={(e) => { e.preventDefault(); load(q); }}>
          <div className="flex items-center gap-2 rounded-md border border-[#1A1F2C]/15 bg-white px-2">
            <Search size={14} className="text-[#5C6B7A]" />
            <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search recipient or subject" className="border-0 shadow-none focus-visible:ring-0 px-0 w-56" data-testid="email-log-search" />
          </div>
          <Button type="submit" variant="outline" size="sm" disabled={busy} className="rounded-md" data-testid="email-log-refresh"><RefreshCw size={13} className={busy ? "animate-spin" : ""} /></Button>
        </form>
      </div>
      <div className="mt-4 rounded-lg border border-[#1A1F2C]/10 overflow-hidden">
        {!data ? <div className="p-6 text-sm text-[#5C6B7A]">Loading…</div> : data.items.length === 0 ? (
          <div className="p-6 text-sm text-[#5C6B7A]" data-testid="email-log-empty">No emails logged yet.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-[#F0EBE1] text-left text-xs uppercase tracking-wider text-[#5C6B7A]">
              <tr><th className="px-3 py-2">When</th><th className="px-3 py-2">To</th><th className="px-3 py-2">Subject</th><th className="px-3 py-2">Status</th></tr>
            </thead>
            <tbody>
              {data.items.map((e, i) => (
                <tr key={i} className="border-t border-[#1A1F2C]/5" data-testid={`email-log-row-${i}`}>
                  <td className="px-3 py-2 whitespace-nowrap text-xs text-[#5C6B7A]">{new Date(e.at).toLocaleString()}</td>
                  <td className="px-3 py-2 text-xs break-all">{e.to}</td>
                  <td className="px-3 py-2 text-xs">{e.subject}</td>
                  <td className="px-3 py-2 text-xs">{e.sent ? <span className="text-[#2B3A67] font-semibold">Sent</span> : <span className="text-red-600 font-semibold" title={e.error || ""}>Failed{e.error ? ` · ${e.error.slice(0, 60)}` : ""}</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </section>
  );
}
